import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import EmojiSelector from "./EmojiSelector";
import { uploadImage } from "../../../unit/UploadImage";
import { extractLoginData } from "../../../unit/UserUtil";
import dsteem from "../../../unit/DsteemUtil";
import { extractImage } from "../../../unit/Tools";
import { ElMessage, ElLoading } from "element-plus";
import { fa } from "element-plus/es/locale";
export default {
  name: "CommentForm",
  components: {
    EmojiSelector: EmojiSelector
  },
  props: {
    placeholder: {
      type: String,
      "default": "输入评论..."
    },
    id: {
      type: [String, Number],
      "default": "comment-root"
    },
    comment: {
      type: Object,
      "default": function _default() {}
    },
    parent: {
      type: Object,
      "default": function _default() {}
    },
    rootPost: {
      type: Object,
      "default": function _default() {}
    },
    uploadImg: {
      type: Function,
      "default": null
    }
  },
  data: function data() {
    return {
      focus: false,
      // * 聚焦状态
      value: "",
      // * 输入框值
      imgSrc: "",
      // * 粘贴的图片src
      showEmojiSelector: false,
      // * 表情选择框状态
      richInput: null,
      language: localStorage.getItem("locale") == "zh" ? "zh-CN" : "en",
      toolbars: {
        bold: true,
        // 粗体
        italic: true,
        // 斜体
        header: true,
        // 标题
        underline: true,
        // 下划线
        strikethrough: true,
        // 中划线
        mark: true,
        // 标记
        superscript: true,
        // 上角标
        subscript: true,
        // 下角标
        quote: true,
        // 引用
        ol: true,
        // 有序列表
        ul: true,
        // 无序列表
        link: true,
        // 链接
        imagelink: true,
        // 图片链接
        code: true,
        // code
        table: true,
        // 表格
        fullscreen: false,
        // 全屏编辑
        readmodel: false,
        // 沉浸式阅读
        htmlcode: true,
        // 展示html源码
        help: false,
        // 帮助

        /* 1.3.5 */
        undo: false,
        // 上一步
        redo: false,
        // 下一步
        trash: true,
        // 清空
        save: false,
        // 保存（触发events中的save事件）

        /* 1.4.2 */
        navigation: false,
        // 导航目录

        /* 2.1.8 */
        alignleft: true,
        // 左对齐
        aligncenter: true,
        // 居中
        alignright: true,
        // 右对齐

        /* 2.2.1 */
        subfield: false,
        // 单双栏模式
        preview: false // 预览

      },
      loginData: null,
      imageList: [],
      loadingInstance: null,
      dialogVisible: false,
      uploadPercentage: 0
    };
  },
  computed: {
    // 是否为顶部评论表单
    isRoot: function isRoot() {
      return this.id === "comment-root";
    },
    // 是否为回复中的表单
    isSub: function isSub() {
      return this.id.split("-").length === 3;
    },
    className: function className() {
      return this.isRoot ? "comment-root" : this.isSub ? "reply sub-reply" : "reply";
    }
  },
  mounted: function mounted() {
    /*  this.richInput = this.$refs.input;
    !this.isRoot && this.richInput.focus(); */
    //this.richInput.addEventListener("paste", this.handlePaste);

    /* this.$once("hook:beforeDestroy", () =>
      richInput.removeEventListener("paste", this.handlePaste)
    ); */
  },
  beforeUnmount: function beforeUnmount() {
    /*  this.richInput.removeEventListener("paste", this.handlePaste); */
  },
  methods: {
    // * 点击评论
    handleSubmit: function handleSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var user, input, json_metadata, _that, permlink, postResult, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.value.trim()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                user = _this.comment && _this.comment.user || null;
                _this.loginData = extractLoginData();
                _this.imageList = extractImage(_this.value);
                _this.loadingInstance = ElLoading.service({
                  fullscreen: true
                });

                if (!_this.loginData) {
                  _context.next = 34;
                  break;
                }

                input = new Object();
                input.postingKey = _this.loginData[1];
                input.author = _this.loginData[0];
                input.body = _this.value;
                input.parent_permlink = _this.rootPost && _this.rootPost.permlink ? _this.rootPost.permlink : _this.comment && _this.comment.user && _this.comment.user.permlink ? _this.comment.user.permlink : _this.parent.user.permlink;
                input.parent_author = _this.rootPost && _this.rootPost.parent_author ? _this.rootPost.parent_author : _this.comment && _this.comment.user && _this.comment.user.name ? _this.comment.user.name : _this.parent.user.name;
                input.title = "";
                json_metadata = new Object();
                json_metadata.app = "boylikegirl.club/0.1";
                json_metadata.format = "markdown+html";
                json_metadata.image = _this.imageList;
                json_metadata.tags = input.taglist;
                input.json_metadata = JSON.stringify(json_metadata);

                if (!(_this.loginData[4] == "true")) {
                  _context.next = 26;
                  break;
                }

                _that = _this;
                permlink = Math.random().toString(36).substring(2);

                try {
                  window.steem_keychain.requestPost(input.author, input.title, input.body, input.parent_permlink, input.parent_author, input.json_metadata, permlink, "", function (response) {
                    ElMessage({
                      message: _that.$t("success.postSuccess"),
                      type: "success"
                    });

                    if (_that.loadingInstance) {
                      _that.loadingInstance.close();
                    }

                    var data = {
                      id: _that.id,
                      content: _that.value,
                      imgSrc: _that.imgSrc,
                      reply: _that.isSub && JSON.parse(JSON.stringify(user)) || null,
                      createAt: new Date(),
                      likes: 0,
                      callback: function callback() {
                        _that.isRoot ? _that.reset() : _that.close();
                      }
                    };

                    if (!_that.isSub) {
                      data.children = [];
                    }

                    _that.$emit("form-submit", {
                      newComment: data,
                      parent: _that.parent
                    });
                  });
                } catch (ex) {//
                }

                _context.next = 34;
                break;

              case 26:
                _context.next = 28;
                return dsteem.postBlog(input);

              case 28:
                postResult = _context.sent;
                if (postResult.id) ElMessage({
                  message: _this.$t("success.postSuccess"),
                  type: "success"
                });

                if (_this.loadingInstance) {
                  _this.loadingInstance.close();
                } else {
                  ElMessage.error(_this.$t("error.postError"));

                  if (_this.loadingInstance) {
                    _this.loadingInstance.close();
                  }
                }

                data = {
                  id: _this.id,
                  content: _this.value,
                  imgSrc: _this.imgSrc,
                  reply: _this.isSub && JSON.parse(JSON.stringify(user)) || null,
                  createAt: new Date(),
                  likes: 0,
                  callback: function callback() {
                    _this.isRoot ? _this.reset() : _this.close();
                  }
                };

                if (!_this.isSub) {
                  data.children = [];
                }

                _this.$emit("form-submit", {
                  newComment: data,
                  parent: _this.parent
                });

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // * 重置组件状态
    reset: function reset() {
      this.value = "";
    },
    // * 销毁组件
    close: function close() {
      this.$emit("form-delete", this.id);
    },
    // * 选择表情
    openEmojiSelector: function openEmojiSelector() {
      this.showEmojiSelector = !this.showEmojiSelector;
    },
    // * 关闭选择表情组件
    closeEmojiSelector: function closeEmojiSelector() {
      if (this.showEmojiSelector) {
        this.showEmojiSelector = false;
      }
    },
    uploadImageCallback: function uploadImageCallback(res) {
      this.uploadPercentage = Math.floor(res.loaded / res.total * 100);
    },
    imgAdd: function imgAdd(pos, $file) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var url;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.dialogVisible = true;
                _context2.next = 3;
                return uploadImage($file, _this2.uploadImageCallback);

              case 3:
                url = _context2.sent;

                _this2.$refs.md.$img2Url(pos, url);

                _this2.dialogVisible = false;
                _this2.uploadPercentage = 0;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};